import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { UserService } from "../../Services/user.service";
import { takeUntil, toArray } from "rxjs/operators";
import { environment } from "../../../environments/environment";
import { ObsidiamJweComponent } from "projects/obsidiam-jwe/src/public-api";
import { map } from "rxjs/operators";
import { Observable } from "rxjs/Observable";
import { filter } from "rxjs/operators";
import "rxjs/add/operator/map";

@Injectable({ providedIn: "root" })
export class ConsumerService {
  endPoints: any;
  endPointIsJwe = false;

  constructor(
    private http: HttpClient,
    private userService: UserService,
    private obsidiamJweComponent: ObsidiamJweComponent
  ) {}

  static STATUS_CODE_SUCCESS = "0";
  baseUrl: any = environment.apiObsicashUrl;
  unsubscribe$: Subject<void> = new Subject<void>();

  /**
   * POST
   */
  post(urlWebService: any, params: {}, etag: string = "NA"): Observable<any> {
    this.endPointIsJwe = this.isEndPointIsJwe(urlWebService.url);
    //
    const url = `${this.baseUrl}${urlWebService.url}`;
    const headers = this.generateHeaders(etag, this.endPointIsJwe);
    return this.endPointIsJwe
      ? this.obsidiamJweComponent.mapObservable(
          this.http.post(url, params, {
            headers,
            responseType: "text",
          })
        )
      : this.http
          .post(url, params, { headers })
          .pipe(takeUntil(this.unsubscribe$));
  }

  /**
   * PUT
   */
  put(urlWebService: any, params: {}, etag: string = "NA"): Observable<any> {
    this.endPointIsJwe = this.isEndPointIsJwe(urlWebService);
    const url = `${this.baseUrl}${urlWebService}`;
    const headers = this.generateHeaders(etag, this.endPointIsJwe);

    return this.endPointIsJwe
      ? this.obsidiamJweComponent.mapObservable(
          this.http.put(url, params, {
            headers,
            responseType: "text",
          })
        )
      : this.http
          .put(url, params, { headers })
          .pipe(takeUntil(this.unsubscribe$));
  }

  private isEndPointIsJwe(urlWebService: any) {
    //
    this.endPoints = JSON.parse(sessionStorage.getItem("endPoints"));
    if (this.endPoints) {
      return this.endPoints.filter((x) => urlWebService.includes(x)).length > 0
        ? true
        : false;
    } else {
      return false;
    }
  }

  /**
   * DELETE
   */
  delete(
    urlWebService: string,
    complementUrl: any,
    etag: string = "NA"
  ): Observable<any> {
    this.endPointIsJwe = this.isEndPointIsJwe(urlWebService);
    const url = `${this.baseUrl}${urlWebService}${complementUrl}`;
    const headers = this.generateHeaders(etag, this.endPointIsJwe);
    return this.endPointIsJwe
      ? this.obsidiamJweComponent.mapObservable(
          this.http.delete(url, {
            headers,
            responseType: "text",
          })
        )
      : this.http.delete(url, { headers }).pipe(takeUntil(this.unsubscribe$));
  }

  /**
   * GET
   */
  get(
    urlWebService: any,
    complementUrl = "",
    etag: string = "NA",
    language: string = undefined
  ): Observable<any> {
    this.endPointIsJwe = this.isEndPointIsJwe(urlWebService);
    let url = `${this.baseUrl}${urlWebService}${complementUrl}`;
    if(url.includes('?')){
      const random = '&' + this.randomString(10, '0123456789');
      url = url + random;
    }
    const headers = this.generateHeaders(etag, this.endPointIsJwe, language);
    return this.endPointIsJwe
      ? this.obsidiamJweComponent.mapObservable(
          this.http.get(url, {
            headers,
            responseType: "text",
          })
        )
      : this.http.get(url, { headers });
  }
  
  randomString(length, chars) {
    var result = '';
    for (var i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
    return result;
  }

  getNotJWT(urlWebService: any, etag: string = "NA"): Observable<any> {
    this.endPointIsJwe = this.isEndPointIsJwe(urlWebService);
    const url = `${this.baseUrl}${urlWebService}`;
    const headers = this.generateHeadersNotJWT(etag, this.endPointIsJwe);
    return this.endPointIsJwe
      ? this.obsidiamJweComponent.mapObservable(
          this.http.get(url, {
            headers,
            responseType: "text",
          })
        )
      : this.http.get(url, { headers });
  }

  /**
   * generateHeaders
   *
   * Genera el header necesario para consumir el servicio.
   */
  private generateHeaders(
    etag: string,
    jwe: boolean,
    language: string = undefined
  ): HttpHeaders {
    const tokenData = this.userService.getToken();
    const loggedData = this.userService.getLoggedData();
    const headers = new HttpHeaders()
      .set("Authorization", "Bearer " + tokenData.token)

      .set("ETag", etag)
      .set(
        "Content-Type",
        jwe ? "text/plain; charset=utf-8" : "application/json; charset=utf-8"
      )
      .set("Accept", jwe ? "text/plain" : "application/json")
      .set(
        "Accept-Language",
        language || loggedData.preferredLanguage || loggedData.locale
      );
    return headers;
  }

  /**
   * generateHeaders
   *
   * Genera el header necesario para consumir el servicio.
   */
  private generateHeadersNotJWT(etag: string, jwe: boolean): HttpHeaders {
    const headers = new HttpHeaders()
      .set("ETag", etag)
      .set(
        "Content-Type",
        jwe ? "text/plain; charset=utf-8" : "application/json; charset=utf-8"
      )
      .set("Accept", jwe ? "text/plain" : "application/json");
    return headers;
  }
}